import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input } from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm1 } from "../components/Validacao";
import { db, auth, storage } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

const Form1 = () => {
  const [dados, setDados] = useState({});
  const [erro, setErro] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setDados({ ...dados, [name]: value });
  };

  const uploadFile = async (file, docPath, docUrl) => {
    if (!file) return;

    setLoading(true);

    const path = ref(storage, `passe2024/${uid}/${docPath}`);

    const upload = uploadBytesResumable(path, file, file.type);

    upload.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(upload.snapshot.ref).then((url) => {
          setDados({ ...dados, [docUrl]: url });
          setLoading(false);
        });
      }
    );
  };

  const setData = async () => {
    const email = auth?.currentUser?.email;

    await setDoc(
      doc(db, "passe2024", uid),
      { ...dados, email: email, uid: uid, status: "p" },
      { merge: true }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const err = ValidaForm1(dados);

    if (err) {
      setErro(err);
      setLoading(false);
    } else {
      setData().then(() => navigate("../home"));
    }
  };

  const getData = async () => {
    const qry = await getDoc(doc(db, "passe2024", uid));

    const data = qry.data();

    const status = data?.status;

    if (!status || status === "e") {
      setDados(data);
      setLoading(false);
    } else {
      navigate("../home");
    }
  };

  const checkLogin = async () => {
    if (uid) getData();
    else
      onAuthStateChanged(auth, (user) => {
        if (user?.uid) {
          uid = user.uid;
          getData();
        } else navigate("../login");
      });
  };

  useEffect(() => {
    checkLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      <Frame
        body={
          <form
            className="text-start"
            autoComplete="off"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="row mt-2">
              <div className="col-sm-12">
                <Input
                  id="nome"
                  label="Nome"
                  type="text"
                  className={erro.nome && "is-invalid"}
                  placeholder="Conforme o documento"
                  value={dados?.nome || ""}
                  onChange={handleChange}
                  erro={erro.nome}
                  autoFocus
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-4">
                <Input
                  id="documento"
                  label="Documento"
                  type="number"
                  className={erro.documento && "is-invalid"}
                  placeholder="Digite o documento"
                  value={dados?.documento || ""}
                  onChange={handleChange}
                  erro={erro.documento}
                />
              </div>

              <div className="col-sm-4">
                <Input
                  id="fone1"
                  label="Fone 1"
                  type="number"
                  className={erro.fone1 && "is-invalid"}
                  placeholder="Digite o telefone"
                  value={dados?.fone1 || ""}
                  onChange={handleChange}
                  erro={erro.fone1}
                />
              </div>
              <div className="col-sm-4">
                <Input
                  id="fone2"
                  label="Fone 2"
                  type="number"
                  className={erro.fone2 && "is-invalid"}
                  placeholder="Digite o telefone"
                  value={dados?.fone2 || ""}
                  onChange={handleChange}
                  erro={erro.fone2}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-12">
                <Input
                  id="endereco1"
                  label="Endereço"
                  type="text"
                  className={erro.endereco1 && "is-invalid"}
                  placeholder="Digite o endereço"
                  value={dados?.endereco1 || ""}
                  onChange={handleChange}
                  erro={erro.endereco1}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-4">
                <Input
                  id="numero1"
                  label="Número"
                  type="text"
                  className={erro.numero1 && "is-invalid"}
                  placeholder="000"
                  value={dados?.numero1 || ""}
                  onChange={handleChange}
                  erro={erro.numero1}
                />
              </div>
              <div className="col-sm-4">
                <Input
                  id="bairro1"
                  label="Bairro"
                  type="text"
                  className={erro.bairro1 && "is-invalid"}
                  placeholder="Digite o bairro"
                  value={dados?.bairro1 || ""}
                  onChange={handleChange}
                  erro={erro.bairro1}
                />
              </div>
              <div className="col-sm-4">
                <Input
                  id="cidade"
                  label="Cidade"
                  className={erro.cidade && "is-invalid"}
                  placeholder="Digite sua cidade"
                  value={dados?.cidade || ""}
                  onChange={handleChange}
                  erro={erro.cidade}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-12">
                <Input
                  id="complemento1"
                  label="Complemento"
                  type="text"
                  className={erro.complemento1 && "is-invalid"}
                  placeholder="Ponto de referência (opcional)"
                  value={dados?.complemento1 || ""}
                  onChange={handleChange}
                  erro={erro.complemento1}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-12">
                <Input
                  id="imgFoto"
                  label="Foto para Carteirinha"
                  type="file"
                  accept="image/*"
                  className={erro.foto && "is-invalid"}
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "foto", "urlFoto")
                  }
                  erro={erro.foto}
                  url={dados?.urlFoto}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-12 d-grid">
                <button type="submit" className="btn btn-primary">
                  ENVIAR
                </button>
              </div>
            </div>
          </form>
        }
        title="Dados Cadastrais"
      />
    </>
  );
};

export default Form1;
